module.exports = __webpack_public_path__ + "static/img/project_3.ec18813.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/project_3.jpg
// module id = dGJy
// module chunks = 0